import * as React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { DocsSidebar } from '@/components/docs/DocsSidebar'
import { TableOfContents } from '@/components/docs/TableOfContents'

interface DocPage {
  path: string
  label: string
}

const DOC_PAGES: DocPage[] = [
  { path: '/docs', label: 'Overview' },
  { path: '/docs/create-ad', label: 'Create Ad' },
  { path: '/docs/create-image', label: 'Create Image' },
  { path: '/docs/products', label: 'Products' },
  { path: '/docs/assets', label: 'Asset Library' },
  { path: '/docs/jobs', label: 'Jobs' },
]

function MobileDocNav() {
  const navigate = useNavigate()
  const currentPath = window.location.pathname

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    navigate(event.target.value)
  }

  return (
    <div className="md:hidden mb-6">
      <select
        aria-label="Navigate docs"
        value={currentPath}
        onChange={handleChange}
        className="w-full rounded-md border border-border bg-background text-foreground text-sm px-3 py-2 focus:outline-none focus:ring-1 focus:ring-foreground/30"
      >
        {DOC_PAGES.map(({ path, label }) => (
          <option key={path} value={path}>
            {label}
          </option>
        ))}
      </select>
    </div>
  )
}

export function DocsLayout() {
  return (
    <div className="flex gap-10">
      <aside className="hidden md:block w-56 shrink-0 sticky top-6 self-start">
        <DocsSidebar />
      </aside>

      <main className="flex-1 min-w-0 pb-20">
        <MobileDocNav />
        <div className="max-w-[720px] mx-auto">
          <Outlet />
        </div>
      </main>

      <TableOfContents />
    </div>
  )
}
